import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  Button,
} from "@mui/material";
import Topheader from "../../Layout/header/header";
import Sidebar from "../../page/oem-admin/settings/sidebar/sidebar";
import CampaignsTable from "./CampaignsTable";
import CreateCampaignDialog from "./CreateCampaignDialog";
import { fetchWelcomeWizardCampaign } from "../../Services/redux/Welcome-wizard/WelcomeWizardActions";
import {fetchOemAdminEcuDetails} from "../../Services/redux/Ecu-types/OemAdminEcuActions";
import {fetchAdminCountriesDetails} from "../../Services/redux/Oem-admin-counties/OemAdminCountryDetailsActions";
import { fetchClusterNumberIdp } from "../../Services/redux/ClusterNumber/ClusterNumberActions";
import {fetchMakeModelYearForPortfolio} from "../../Services/redux/MakeModelYear/MakeModelYearActions";

function WelcomeWizard() {
  const dispatch = useDispatch();
  const [dataFromChild, setDataFromChild] = useState("");
  const [open, setOpen] = useState(false);
   const [sortedWelcomeWizardData, setSortedWelcomeWizardData] = useState([]);
  const welcomeWizardData = useSelector((state) => state.welcomeWizard.campaignData);
  const ecuTypeData = useSelector((state) => state.oemAdminEcuTypes.ecu);
  const countries = useSelector((state) => state.oemAdminCountires.countries);
  const clusterNumberData = useSelector((state) => state.clusterNumberReducer.clusterNumberData);
  const MMYforPortfolio = useSelector((state) => state.makeModelYearReducer.mmyData);
  useEffect(()=>{
    dispatch(fetchWelcomeWizardCampaign());
    dispatch(fetchOemAdminEcuDetails());
    dispatch(fetchAdminCountriesDetails());
     dispatch(fetchMakeModelYearForPortfolio(sessionStorage.getItem("portfolioId")));
    if(sessionStorage.getItem("idpLogin") === "true"){
      dispatch(fetchClusterNumberIdp());
    }
  },[])

  useEffect(() => {
    if (welcomeWizardData && welcomeWizardData.length > 0) {
      const sorted = [...welcomeWizardData].sort((a, b) => {
        // If a has default:true, it should come first (return -1)
        // If b has default:true, it should come first (return 1)
        // If neither or both have default:true, maintain original order (return 0)
        if (a.default === true && b.default !== true) return -1;
        if (a.default !== true && b.default === true) return 1;
        return 0;
      });
      setSortedWelcomeWizardData(sorted);
    } else {
      setSortedWelcomeWizardData([]);
    }
  }, [welcomeWizardData]);

  function handleDataFromChild(data) {
    setDataFromChild(data);
  }
  return (
    <>
      <Topheader />
      <Box
        sx={{
          marginTop: "3%",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "-webkit-box",
          }}
        >
          <Sidebar
            sendDataToParent={handleDataFromChild}
            page="Welcome Wizard"
          />
          <div
            style={{ display: "flex", flexDirection: "column", width: "70%" }}
          >
            <Box
              className="notifications-main- section"
              sx={{ flexGrow: 1, marginLeft: "20px" }}
            >
              <Box
                justifyContent="space-between"
                alignItems="center"
                mb={2}
                width="89%"
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    marginTop: "33px",
                    fontWeight: "500",
                  }}
                >
                  {dataFromChild} - Welcome Wizard
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "24px",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    borderTop: "1px solid #12141533",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: "500",
                        marginTop: "5px",
                      }}
                    >
                      Apps for Welcome Wizard
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{ textTransform: "none", maxWidth: "none" }}
                      disabled={
                        sessionStorage.getItem("readonly_OemAdmin") === "true"
                      }
                      onClick={() => setOpen(true)}
                    >
                      Create Campaign
                    </Button>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "5px",
                    justifyContent: "flexStart",
                    flexDirection: "column",
                    marginLeft: "1px",
                    gap: "8px",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontWeight: 400,
                      fontSize: "14px",
                      leadingTrim: "NONE",
                      lineHeight: "100%",
                      letterSpacing: "0px",
                      color: "#717273",
                    }}
                  >
                    Manage the listing of an apps in the headunit upfront.
                  </Typography>
                </Box>
                <Box
                 sx={{
                    display: "flex",
                    marginTop: "5px",
                    justifyContent: "flexStart",
                    flexDirection: "column",
                    marginLeft: "1px",
                    gap: "8px",
                  }}
                >
                {
                <CampaignsTable campaignData={sortedWelcomeWizardData} />
                }
                
                {  open && MMYforPortfolio && MMYforPortfolio.length > 0 &&
                <CreateCampaignDialog open={open} ecuTypeData={ecuTypeData} clusterNumberData={clusterNumberData} countries={countries} model={MMYforPortfolio[0].models} onClose={() => setOpen(false)} />
                }
                </Box>
              </Box>
            </Box>
          </div>
        </Box>
      </Box>
    </>
  );
}

export default WelcomeWizard;
